import US_POLO from '../../../image/Brands/US_POLO.png';
import ELLE from '../../../image/Brands/ELLE.png';
import PECKHAM_RAY from '../../../image/Brands/PECKHAM_RAY.png';
import DUCHAMP from '../../../image/Brands/Duchamp_London_logo.png';
import JACK_WILLS from '../../../image/Brands/JACK_WILLES.png';
import PEN_FIELD from '../../../image/Brands/PENFIELD.png';
import BEN_SHARMEN from '../../../image/Brands/logo-ben-sherman.png';
import PENGUIN from '../../../image/Brands/PENGUIN.png';
import JUCY_COUNTER from '../../../image/Brands/JUICY_COUNTER.png';
import EQUUS from '../../../image/Brands/EQUUS.png';
import ROCHAS from '../../../image/Brands/ROCHAS.png';
import LEE from '../../../image/Brands/LEE.png';
import LYLE_SCOTT from '../../../image/Brands/Lyle_and_Scott_logo.png';





export const brands = [
  { name: 'US_POLO', logo: US_POLO },
  { name: 'ELLE', logo: ELLE },
  { name: 'PECKHAM_RAY', logo: PECKHAM_RAY },
  { name: 'DUCHAMP', logo: DUCHAMP },
  { name: 'JACK_WILLS', logo: JACK_WILLS },
  { name: 'PEN_FIELD', logo: PEN_FIELD },
  { name: 'BEN_SHARMEN', logo: BEN_SHARMEN },
  { name: 'PENGUIN', logo: PENGUIN },
  { name: 'JUCY_COUNTER', logo: JUCY_COUNTER },
  { name: 'EQUUS', logo: EQUUS },
  { name: 'ROCHAS', logo: ROCHAS },
  { name: 'LEE', logo: LEE },
  { name: 'LYLE_SCOTT', logo: LYLE_SCOTT },
];